import { PendoButton, PendoForm, PendoFormItem, PendoInput, PendoCard, PendoIcon } from '@pendo/components';

//
//
//
//
//
//
//
//
//
//
//
var script$5 = {
  name: 'LoginBackground',
  props: {
    isNight: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#F4F4F7'
    }
  },
  computed: {
    computedBackgroundColor() {
      if (this.isNight) {
        return '#2A2C35';
      }

      return this.backgroundColor;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: [{
      'is-night': _vm.isNight
    }, 'login-background'],
    style: {
      'background-color': _vm.computedBackgroundColor
    }
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_vm._t("logo")], 2), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-5275be1e_0", {
    source: ".login-background[data-v-5275be1e]{position:fixed;top:0;right:0;bottom:0;left:0;overflow:hidden;display:flex;align-items:center;justify-content:center}@media only screen and (max-width:767px){.login-background[data-v-5275be1e]{display:flex;flex-direction:column;padding:35px 15px 0 15px}}.login-logo[data-v-5275be1e]{position:absolute;top:33px;left:33px}@media only screen and (max-width:767px){.login-logo[data-v-5275be1e]{align-self:center;position:relative;top:auto;left:auto}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = "data-v-5275be1e";
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

function getTimeOfDay(currentTime) {
  // time of day
  const h = currentTime.getHours(); // 12am -> 5:59am, 10pm -> 11:59pm (night)

  if (h >= 0 && h < 6 || h >= 22) {
    return 0;
  } // 6am -> 11:59am (morning)


  if (h >= 6 && h < 12) {
    return 1;
  } // 12pm -> 5:59pm (afternoon)


  if (h >= 12 && h < 18) {
    return 2;
  } // 6pm -> 9:59pm


  if (h >= 18 && h < 22) {
    return 3;
  }
}
function isNightTime(currentTime) {
  return getTimeOfDay(currentTime) === 0 || getTimeOfDay(currentTime) === 3;
}

//
var script$4 = {
  name: 'LoginTemplate',
  components: {
    PendoButton,
    PendoForm,
    PendoFormItem,
    PendoInput,
    LoginBackground: __vue_component__$5
  },
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    description: {
      type: String,
      default: 'This is the description.'
    },
    buttonText: {
      type: String,
      default: 'Button Text'
    },
    inputType: {
      type: String,
      default: 'text'
    },
    formInputLabel: {
      type: String,
      default: 'Some Label'
    },
    theme: {
      type: String,
      default: 'app'
    },
    formRef: {
      type: String,
      default: 'login-form'
    },
    time: {
      type: Date,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    },
    isWhiteLabel: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      callValidate: false,
      model: {
        [this.inputType]: this.value
      }
    };
  },

  computed: {
    isNight() {
      const useNightMode = this.time ? isNightTime(this.time) : false;
      return !this.isWhiteLabel && useNightMode;
    },

    textColor() {
      const dayTextColor = '#2A2C35';
      const nightTextColor = '#F4F4F7';
      return this.isNight ? nightTextColor : dayTextColor;
    }

  },
  methods: {
    onClick() {
      this.callValidate = true;
      this.$emit('on-click', this.model[this.inputType]);
    },

    handleInvalidForm() {
      this.callValidate = false;
      this.$emit('invalid-form');
    },

    handleValidForm() {
      this.callValidate = false;
      this.$emit('form-validated');
    },

    onInput() {
      this.$emit('on-input', this.model[this.inputType]);
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', {
    attrs: {
      "is-night": _vm.isNight
    },
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm.isNight ? _vm._t("nightLogo") : _vm._t("logo")];
      },
      proxy: true
    }], null, true)
  }, [_vm._v(" "), _c('div', {
    staticClass: "center-block",
    style: {
      color: _vm.textColor
    }
  }, [_c('h1', {
    staticClass: "center-block__header"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "center-block__inner-width-wrapper"
  }, [_c('p', {
    staticClass: "center-block__helper-text"
  }, [_vm._v("\n                " + _vm._s(_vm.description) + "\n            ")]), _vm._v(" "), _c('pendo-form', {
    staticClass: "center-block__form",
    attrs: {
      "form-ref": _vm.formRef,
      "form-defaults": _vm.model,
      "call-validate": _vm.callValidate
    },
    on: {
      "invalidForm": _vm.handleInvalidForm,
      "formValidated": _vm.handleValidForm
    }
  }, [_c('pendo-form-item', {
    attrs: {
      "data-cy": "login-template--input",
      "rules": _vm.rules,
      "prop": _vm.inputType
    }
  }, [_c('pendo-input', {
    class: {
      'center-block__form-night': _vm.isNight
    },
    attrs: {
      "label": _vm.formInputLabel,
      "tabindex": "1"
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: _vm.model[_vm.inputType],
      callback: function ($$v) {
        _vm.$set(_vm.model, _vm.inputType, $$v);
      },
      expression: "model[inputType]"
    }
  })], 1), _vm._v(" "), _c('pendo-button', {
    staticClass: "center-block__button",
    attrs: {
      "data-cy": "login-template--reset-link",
      "theme": _vm.theme,
      "type": "primary",
      "block": "",
      "label": _vm.buttonText,
      "tabindex": "2"
    },
    on: {
      "click": _vm.onClick
    }
  })], 1)], 1)])]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-ed27631c_0", {
    source: ".center-block[data-v-ed27631c]{width:33%;margin:0 auto;min-width:500px}@media only screen and (max-width:767px){.center-block[data-v-ed27631c]{padding-top:25px;min-width:auto;width:100%;max-width:500px}}.center-block .center-block__header[data-v-ed27631c]{font-family:Sora;font-weight:600;font-size:36px;line-height:42px;margin-top:0;white-space:normal;text-align:center}@media only screen and (max-width:767px){.center-block .center-block__header[data-v-ed27631c]{font-size:32px}}.center-block .center-block__helper-text[data-v-ed27631c]{font-size:18px;font-weight:400;margin:1em auto 2em;text-align:center}.center-block .center-block__inner-width-wrapper[data-v-ed27631c]{margin:0 auto;max-width:380px;min-width:auto}.center-block[data-v-ed27631c] .pendo-input__field{background:0 0!important}.center-block .center-block__form-night[data-v-ed27631c] .pendo-input__label{color:#f4f4f7}.center-block .center-block__form-night[data-v-ed27631c] .pendo-input__field:hover{border-color:#fff}.center-block .center-block__form-night[data-v-ed27631c]  input{color:#fff}.center-block .center-block__button[data-v-ed27631c]{margin-top:20px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-ed27631c";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
var script$3 = {
  name: 'ForgotPassword',
  components: {
    LoginTemplate: __vue_component__$4
  },
  props: {
    /**
     * Time of the day
     */
    time: {
      type: Date,
      default: () => new Date()
    },

    /**
     * Email of the user
     */
    email: {
      type: String,
      default: ''
    },

    /**
     * If the domain is a white label domain
     */
    isWhiteLabel: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      description: "Please enter your email address and we'll send you a link to reset your password.",
      buttonText: 'Send Email',
      callValidate: false,
      rules: [{
        type: 'email',
        message: 'Please input a valid email address',
        trigger: ['blur']
      }, {
        required: true,
        message: 'Email address is required',
        trigger: ['blur', 'change']
      }]
    };
  },

  methods: {
    onClick(val) {
      this.$emit('on-click', val);
    },

    onInput(val) {
      this.$emit('on-input', val);
    },

    handleInvalidForm() {
      this.$emit('invalid-form');
    },

    handleValidForm() {
      this.$emit('form-validated');
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-template', {
    attrs: {
      "title": "Forgot Your Password?",
      "description": _vm.description,
      "button-text": "Send Email",
      "input-type": "email",
      "form-input-label": "Email Address",
      "time": _vm.time,
      "rules": _vm.rules,
      "value": _vm.email,
      "is-white-label": _vm.isWhiteLabel
    },
    on: {
      "invalid-form": _vm.handleInvalidForm,
      "form-validated": _vm.handleValidForm,
      "on-click": _vm.onClick,
      "on-input": _vm.onInput
    },
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }, {
      key: "nightLogo",
      fn: function () {
        return [_vm._t("nightLogo")];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
var script$2 = {
  name: 'SuccessEmailCard',
  components: {
    PendoCard,
    PendoIcon
  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-card', {
    staticClass: "success-email-card",
    attrs: {
      "width": "400px",
      "body-min-height": "0",
      "footer-min-height": "0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('div', {
          staticClass: "success-email-card__mail-icon-wrapper"
        }, [_c('pendo-icon', {
          staticClass: "success-email-card__mail-icon",
          attrs: {
            "type": "mail",
            "stroke": "#128297"
          }
        })], 1), _vm._v(" "), _c('h2', {
          staticClass: "success-email-card__title"
        }, [_vm._v("\n            Great, please verify your email.\n        ")]), _vm._v(" "), _c('p', {
          staticClass: "success-email-card__description"
        }, [_vm._v("\n            We emailed you a link to verify your email address and create your password. You should receive it\n            shortly. Don't forget to check your spam folder.\n        ")])];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-3bee713c_0", {
    source: ".success-email-card[data-v-3bee713c]{border:1px solid #dadce5}.success-email-card[data-v-3bee713c] .pendo-card__body{padding:24px}.success-email-card[data-v-3bee713c] .pendo-card__footer{padding:16px 24px}.success-email-card__mail-icon-wrapper[data-v-3bee713c]{display:flex;align-items:center;justify-content:center;width:50px;border-radius:50%;height:50px;background-color:#d9fcff}.success-email-card__title[data-v-3bee713c]{margin:0;font-size:22px;font-weight:700;margin-top:20px;margin-bottom:10px;line-height:1.3em}.success-email-card__description[data-v-3bee713c]{font-size:14px;line-height:1.4}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-3bee713c";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
var script$1 = {
  name: 'ExpiredLinkCard',
  components: {
    PendoIcon,
    PendoButton,
    PendoCard
  },
  methods: {
    goToLogin() {
      window.location.assign('/');
    },

    requestNewLink() {
      this.$emit('request-new-link');
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-card', {
    staticClass: "expired-link-card",
    attrs: {
      "width": "400px",
      "shadow": "always",
      "body-min-height": "0",
      "footer-min-height": "0"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('pendo-button', {
          attrs: {
            "data-cy": "resend-request--button",
            "theme": "app",
            "type": "primary",
            "label": "Resend Request",
            "block": ""
          },
          on: {
            "click": _vm.requestNewLink
          }
        }), _vm._v(" "), _c('span'), _vm._v(" "), _c('pendo-button', {
          attrs: {
            "data-cy": "return-to-login--button",
            "theme": "app",
            "type": "link",
            "label": "Return to Login",
            "block": ""
          },
          on: {
            "click": _vm.goToLogin
          }
        })];
      },
      proxy: true
    }])
  }, [_c('pendo-icon', {
    staticClass: "expired-link-card__alert-circle-icon",
    attrs: {
      "type": "alert-circle",
      "stroke": "#DBA211",
      "size": "25"
    }
  }), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "expired-link-card__title"
  }, [_vm._v("\n            We're sorry, but it looks like this link has expired.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "expired-link-card__description"
  }, [_vm._v("\n            This password reset link has expired. Please try logging in again or resending the request.\n        ")])])], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-7935e65f_0", {
    source: ".expired-link-card[data-v-7935e65f]{border:1px solid #dadce5}.expired-link-card[data-v-7935e65f] .pendo-card__body{padding:24px}.expired-link-card[data-v-7935e65f] .pendo-card__footer{padding:16px 24px}[data-v-7935e65f] .expired-link-card__alert-circle-icon svg{background:#fdefd5;padding:11px;border-radius:27px;margin-bottom:16px}.expired-link-card__title[data-v-7935e65f]{font-size:22px;line-height:1.2}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = "data-v-7935e65f";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
var script = {
  name: 'ExpiredLink',
  components: {
    LoginBackground: __vue_component__$5,
    SuccessEmailCard: __vue_component__$2,
    ExpiredLinkCard: __vue_component__$1
  },

  data() {
    return {
      requestedNewLink: false
    };
  },

  methods: {
    requestNewLink() {
      this.$emit('request-new-link');
      this.requestedNewLink = true;
    }

  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', {
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }], null, true)
  }, [_vm._v(" "), !_vm.requestedNewLink ? _c('expired-link-card', {
    on: {
      "request-new-link": _vm.requestNewLink
    }
  }) : _vm._e(), _vm._v(" "), _vm.requestedNewLink ? _c('success-email-card') : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export { __vue_component__ as ExpiredLink, __vue_component__$3 as ForgotPassword };
